import React from "react";
import { TSubmittalGridRow, TMaterialGridRow } from "../grid-utils";
import { CombinedTimelineDiff } from "./viz/combined-timeline-diff";
import { RasterizedTimelineDiff } from "./viz/rasterized-timeline-diff";
import ActivitySummary from "./activity-summary";
import { PrintColumn } from "./print-columns";

export type PrintRowKind = "submittal" | "material";

type Props = {
  kind: PrintRowKind;
  row: TSubmittalGridRow | TMaterialGridRow;
  projectId: string;
  rasterize?: boolean;
  columns: PrintColumn<any>[];
};

const CELL = "border border-solid border-ciq-gray-400 px-3 py-2 align-top";

// One <tbody> per row groups the summary + detail pair so
// `break-inside: avoid` keeps them on the same printed page; sibling
// <tr>s in a single tbody would split.
function TableRow({ kind, row, projectId, rasterize, columns }: Props) {
  const isSubmittal = kind === "submittal";
  const sRow = isSubmittal ? (row as TSubmittalGridRow) : null;
  const mRow = !isSubmittal ? (row as TMaterialGridRow) : null;

  const Viz = rasterize ? RasterizedTimelineDiff : CombinedTimelineDiff;

  return (
    <tbody className="print:break-inside-avoid">
      <tr data-risk={row.risk_level} className="bg-white">
        {columns.map((col) => (
          <td
            key={col.id}
            className={`${CELL}${col.className ? ` ${col.className}` : ""}`}
          >
            {col.render(row)}
          </td>
        ))}
      </tr>
      <tr>
        <td
          className="border border-solid border-ciq-gray-400 p-4 bg-white relative"
          colSpan={columns.length}
        >
          <div className="mb-4">
            <ActivitySummary row={row} />
          </div>
          <div className="pt-4">
            {isSubmittal ? (
              <Viz
                kind="submittal"
                submittal={sRow!._submittal}
                activityComparison={sRow!._activity}
                projectId={projectId}
              />
            ) : (
              <Viz
                kind="material"
                material={mRow!._material}
                activityComparison={mRow!._activity}
                projectId={projectId}
              />
            )}
          </div>
        </td>
      </tr>
    </tbody>
  );
}

export default React.memo(TableRow);
